<template>
    <img :src="src" v-if="loaded" class="swaychat-bounceIn"  />
</template>

<script>
import axios from 'axios/dist/axios'

export default {
  props: [
    'src'
  ],
  created() {
    this.check()
  },
  destroyed() {
    clearTimeout(this.timer)
  },
  data() {
    return {
      loaded: false,
      timer: null
    }
  },
  methods: {
    check() {
      //console.log('check')
      axios.get(this.src).then(()=>{
        this.loaded = true
      })
      .catch(()=>{

        clearTimeout(this.timer)
        this.timer = setTimeout(()=>{
          this.check()
        },5000)

      })
    }
  }
}

</script>
